import { DateTime } from 'luxon'

type APIDisorder = {
  title_de: string
  title_en: string
  id: number
  created_at: string
  updated_at: string
}

type Disorder = {
  title_de: string
  title_en: string
  id: number
  created_at: DateTime
  updated_at: DateTime
}

/**
 * Parses JSON (formatted as APIDisorder) to the Disorder model
 * @param json
 */
const parseDisorder = function (json: APIDisorder): Disorder {
  return {
    title_de: json.title_de,
    title_en: json.title_en,
    id: json.id,
    created_at: DateTime.fromISO(json.created_at),
    updated_at: DateTime.fromISO(json.updated_at),
  }
}

export { parseDisorder }
export type { Disorder, APIDisorder }
